export const combine = (
  separator: string,
  ...parts: (string | null | undefined)[]
): string => parts.filter(Boolean).join(separator);
